/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type TouchpointDTOBatchJobType =
  (typeof TouchpointDTOBatchJobType)[keyof typeof TouchpointDTOBatchJobType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TouchpointDTOBatchJobType = {
  MONDAY: "MONDAY",
  WRITING: "WRITING",
} as const;
